import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'User',
    column_type: 'id',
  },
  created_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  screen_name: {
    model_name: 'User',
    column_type: 'string',
  },
  is_block: {
    model_name: 'User',
    column_type: 'boolean',
  },
  email: {
    model_name: 'User',
    column_type: 'string',
  },
  role: {
    model_name: 'User',
    column_type: 'belongs_to',
    extra: {
      association_name: 'role',
      model_name: 'Role',
    },
  },
  role_id: {
    model_name: 'User',
    column_type: 'belongs_to',
    extra: {
      association_name: 'role',
      model_name: 'Role',
    },
  },
  creator: {
    model_name: 'User',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  creator_id: {
    model_name: 'User',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  phone: {
    model_name: 'User',
    column_type: 'string',
  },
  avatar: {
    model_name: 'User',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  customer_sources: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_sources',
      model_name: 'CustomerSource',
      foreign_key: 'customer_source_id',
    },
  },
  customer_source_ids: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_sources',
      model_name: 'CustomerSource',
      foreign_key: 'customer_source_id',
    },
  },
  related_users: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'related_users',
      model_name: 'User',
      foreign_key: 'related_user_id',
    },
  },
  related_user_ids: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'related_users',
      model_name: 'User',
      foreign_key: 'related_user_id',
    },
  },
  customer_capacity_limit: {
    model_name: 'User',
    column_type: 'integer',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
